
(function(template){
    define('vue!basicComponents/loadingIndicator',['Vue'],function(Vue){
        return {
            template:template,
            props: ['showLoader']
        }
    })
})('<div class="fetching-loader " v-show="showLoader"> <div></div> <p>{{localStrings.stepper.body.schedule.loading}}</p> </div>');
